import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";

export const PageLayout = ({ eyebrow, title, subtitle, testId, children }) => (
  <div data-testid={testId}>
    <TopBar />
    <Navbar />
    <main>
      <div className="bg-[#08080A] py-14 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            {eyebrow && (
              <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#D8B54A]" data-testid={`${testId}-eyebrow`}>
                {eyebrow}
              </p>
            )}
            <h1
              data-testid={`${testId}-title`}
              className="mt-3 max-w-3xl font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl"
            >
              {title}
            </h1>
            {subtitle && (
              <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#C6C0B4] sm:text-base">{subtitle}</p>
            )}
          </Reveal>
        </div>
      </div>
      {children}
    </main>
    <Footer />
  </div>
);
